var component = require('../../../lib/js/component.js');

function HorizontalTabs() {
    this.initialize = function (element, options) {
        var $element = $(element);
        var _this = this;

        _this.$horizontalTabs = $element.find('.horizontal-tab-container');
        _this.$faqSchemaSpan = $element.find('.faq-schema');
        _this.$faqSchemaScriptTag = $element.find('#faqSchema');
        _this.$tabContent = $element.find('.tab-content');
        _this.$accordionArrow = _this.$horizontalTabs.find('.Horizontal-arrow');
        _this.$horizontalNavTabsList = $element.find('.horizontal-tabs');
        _this.$allHorizontalTabs = _this.$horizontalTabs.find('.horizontal-tab');
        _this.$horizontalMobile = $element.find('.horizontal-tabs-mobile');
        _this.$verticalMobile = $element.find('.vertical-tabs-mobile');
        _this.$collapseHorizontalMobile = _this.$horizontalTabs.find('.panel-collapse:first');
        _this.$titlePanel = $element.find('.horizontalMobile-title');
        _this.$verticalTitlePanel = $element.find('.verticalMobile-title');
        _this.$panelTitle = _this.$horizontalTabs.find('.horizontal-panel-title');
        
        // Get all card images NOT in vertical tabs
        _this.$images = _this.$element.find('img').filter(function() {
            return $(this).parents('.VerticalTabs').length === 0;
        });

        // If the faqSchema span exists and data-is-faq-schema-enabled is True, generate the FAQ SEO Schema
        if(_this.$faqSchemaSpan && _this.$faqSchemaSpan.length > 0 && 
            _this.$faqSchemaSpan.data('is-faq-schema-enabled') === "True" && _this.$tabContent && 
            _this.$tabContent.length > 0)
        {
            _this.buildFaqSchema(_this.$faqSchemaScriptTag, _this.$tabContent);
        }

        var $firstHorizontalTab = _this.$horizontalTabs.find('.horizontal-tab:first');
        var $firstMobileHorizontalTab = _this.$horizontalMobile.find('.horizontal-tab:first');
        var $firstHorizontalTabChild = $firstHorizontalTab.children();
        var $firstHorizontalTabContent = _this.$horizontalTabs.find('.horizontal-tab-content:first');
        var $horizontalTabContent = $element.find('.horizontal-tab-content');
        var $tabCards = $element.find('.Card-container');

        // Add the Horizontal Tabs section Id as the data-deeplink-scrollto value to each horizontal tab, vertical tab container, and tab card
        $horizontalTabContent.each(function () {
            $(this).attr("data-deeplink-scrollto", '#' + element.id);
        });

        $tabCards.each(function() {
            $(this).attr("data-deeplink-scrollto", '#' + element.id);
        });

        $firstHorizontalTab.addClass('active');
        $firstHorizontalTab.attr('aria-selected', 'true');
        $firstMobileHorizontalTab.attr('aria-selected', 'true');
        $firstHorizontalTabContent.addClass('active');

        // Load the first image
        if(_this.$images != null && _this.$images.length != 0) {
            $.cloudinary.responsive();
        }

        if (!_this.$horizontalTabs.hasClass('expEditorEditing')) {
            $cloneToAppend = _this.$allHorizontalTabs.clone();
            $cloneToAppend.detach().appendTo(_this.$horizontalMobile);
            _this.$allHorizontalTabs.detach().appendTo(_this.$horizontalNavTabsList);
        }

        _this.$titlePanel[0].innerHTML = $firstHorizontalTab.first().text();

        _this.$horizontalMobileToggle = $element.find('.horizontal-tabs-mobile li');

        _this.$collapseHorizontalMobile.on('show.bs.collapse hide.bs.collapse', function () {
            _this.$accordionArrow.toggleClass('flip-arrow');
        });
        _this.$allHorizontalTabs.on('click touch', _this.activeToggle.bind(_this));
        _this.$horizontalMobileToggle.on('click touch', _this.activeToggleMobile.bind(_this));
        _this.$element.on('ht-tab-change', _this.selectTabByElement.bind(_this));

        _this.$allHorizontalTabs.on("keydown", function(e) {
            e.preventDefault();
            var listTabs = _this.$allHorizontalTabs;
            var prevActiveTab = $(".horizontal-tab.active");
            var TabContent = $(".horizontal-tab-content.active");
            var newActiveTab, newTabContent;

            if (e.key === "ArrowLeft") {
                if (prevActiveTab.is(listTabs.first())) {
                    newActiveTab = listTabs.last();
                    newTabContent = $(".tab-content .horizontal-tab-content").last();
                } else {
                    newActiveTab = prevActiveTab.prev('.horizontal-tab');
                    newTabContent = TabContent.prev('.horizontal-tab-content');
                }
            } else if (e.key === "ArrowRight") {
                if (prevActiveTab.is(listTabs.last())) {
                    newActiveTab = listTabs.first();
                    newTabContent = $(".tab-content .horizontal-tab-content").first();
                } else {
                    newActiveTab = prevActiveTab.next('.horizontal-tab');
                    newTabContent = TabContent.next('.horizontal-tab-content');
                }
            }

            if (newActiveTab && newTabContent) {
                TabContent.removeClass('active');
                newTabContent.addClass('active');
                prevActiveTab.removeClass('active').attr('aria-selected', 'false');
                newActiveTab.addClass('active').attr('aria-selected', 'true');
            }
        });
    }

    this.activeToggle = function (e) {
        $(".horizontal-tab.active").attr('aria-selected', 'false');
        $clickedTab = $(e.currentTarget.firstElementChild);
        this.$titlePanel[0].innerHTML = $clickedTab.text();
        $(e.currentTarget).attr('aria-selected', 'true');
        this.$horizontalMobileToggle.find('a[href="' + $clickedTab[0].hash + '"]').tab('show');
        this.$allHorizontalTabs.find('a[href="' + $clickedTab[0].hash + '"]').tab('show');
        
        this.refreshTabImage($clickedTab);
    }

    this.activeToggleMobile = function (e) {
        $(".horizontal-tab.active").attr('aria-selected', 'false');
        $clickedTab = $(e.currentTarget.firstElementChild);
        $(e.currentTarget).attr('aria-selected', 'true');
        this.$titlePanel[0].innerHTML = $clickedTab.text();
        this.$collapseHorizontalMobile.collapse('hide');

        this.$allHorizontalTabs.find('a[href="' + $clickedTab[0].hash + '"]').tab('show');
        
        this.refreshTabImage($clickedTab);
    }

    this.deeplink = function (event, val) {
        var $deeplinkElement = $(event.currentTarget.firstElementChild).find('[data-deeplink="' + val + '"]');

        this.selectTabByElement(null, $deeplinkElement);
    }

    this.selectTabByElement = function(e, $selectedElement) {
        if ($selectedElement != null && $selectedElement.length > 0) {
            var href = null;

            if ($selectedElement.is('.vertical-tab-content, .VerticalTabs, .Card-container')) {
                closestHorizontalTab = $selectedElement.closest('.horizontal-tab-content');
                if (closestHorizontalTab != null && closestHorizontalTab.length > 0) {
                    href = closestHorizontalTab[0].id;
                }
            } else {
                href = $selectedElement[0].id;
            }

            if (href != null) {
                var $tab = this.$horizontalTabs.find('a[href="#' + href + '"]')
                
                if ($tab.length && $tab[0]) {
                    this.$titlePanel[0].innerHTML = $tab[0].innerHTML;
                    this.$allHorizontalTabs.find('a[href="#' + href + '"]').tab('show');
                    this.$horizontalMobileToggle.find('a[href="#' + href + '"]').tab('show');
                }
            }  
        }
    }

    this.refreshTabImage = function(openTab) {
        // Refresh the card image if it hasn't fully loaded yet
        var $openTabImage = this.find(openTab[0].hash).find('img');
        if($openTabImage != null && !$openTabImage.hasClass('is-fully-loaded')) {
            $openTabImage.cloudinary_update();
            $openTabImage.addClass('is-fully-loaded');
        }
    }

    this.buildFaqSchema = function($schemaScriptTag, $tabContent){
        var schemaObj = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity":[]
        };
        var $tabPanel = $tabContent.find(".horizontal-tab-content");
        if($tabPanel && $tabPanel.length > 0){
            $tabPanel.each(function(index, tb){
                var $questionHeadline = $(tb).find(".Card-headline");
                var $answerDiv = $(tb).find(".Card-boxCopy");
                if($questionHeadline && $questionHeadline.length > 0 && 
                    $answerDiv && $answerDiv.length > 0)
                {
                    var cleanedAnswer = $answerDiv.text() !== "" ? $answerDiv.text().replaceAll("\n", "").trim() : "";
                    var faqObj = {
                        "@type":"Question",
                        "name": $questionHeadline.text(),
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": cleanedAnswer
                        }
                    }

                    schemaObj.mainEntity.push(faqObj);
                }
            });
        }

        var schemaJson = JSON.stringify(schemaObj);

        $schemaScriptTag.html(schemaJson);
    }
}

module.exports = component(HorizontalTabs);
